import * as Yup from "yup";
import i18next from "../../i18n";

const phoneRegex =
  /^(?:0?5\d{8}|0?5\d-\d{7}|0?5\d{2}-\d{6}|0?5\d{1}-\d{4}-\d{3})$/;

const multilingualNameRegex = /^[\p{L}\s]+$/u;

const t = i18next.t.bind(i18next);

export const singleNameValidation = (fieldLabel = "Name") =>
  Yup.string()
    .matches(
      multilingualNameRegex,
      t(`validation-error-messages:${fieldLabel}_letters_only`)
    )
    .required(t(`validation-error-messages:${fieldLabel}_required`));

export const fullNameValidation = () =>
  Yup.string()
    .required(t(`validation-error-messages:full_name_required`))
    .matches(
      multilingualNameRegex,
      t(`validation-error-messages:full_name_letters_only`)
    )
    .test(
      "at-least-two-names",
      t(`validation-error-messages:full_name_two_names`),
      (value) => {
        if (!value) return false;
        const parts = value.trim().split(/\s+/);
        return parts.length >= 2 && parts.every((part) => part.length >= 1);
      }
    );

export const phoneValidation = () =>
  Yup.string()
    .required(t("validation-error-messages:phone_required"))
    .matches(phoneRegex, t("validation-error-messages:phone_invalid_format"));

export const emailValidation = () =>
  Yup.string()
    .required(t("validation-error-messages:email_required"))
    .matches(
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      t("validation-error-messages:email_invalid")
    );

export const postalCodeValidation = () =>
  Yup.string()
    .matches(/^\d{4,10}$/, t("validation-error-messages:postal_code_invalid"))
    .required(t("validation-error-messages:postal_code_required"));

export const addressValidation = (fieldLabel = "address") =>
  Yup.mixed().test(
    "address-valid",
    t(`validation-error-messages:${fieldLabel}_required`),
    (value) => {
      // Case 1: simple string
      if (typeof value === "string") {
        return value.trim().length > 0;
      }

      // Case 2: object with some non-empty string values
      if (value && typeof value === "object") {
        return Object.values(value).some(
          (val) => typeof val === "string" && val.trim() !== ""
        );
      }

      // Invalid in all other cases
      return false;
    }
  );
